import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { map, of } from 'rxjs';

export const svgsGuard = () => {
	const router = inject(Router);
	const environment = process.env['NODE_ENV'];

	return of(environment).pipe(
		map((env) => {
			if (env === 'development') {
				return true;
			} else {
				router.navigate(['/404']);
				return false;
			}
		}),
	);
};
